import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule, routingComponents} from './app-routing.module';
import {AppComponent} from './app.component';
import {VacanciesCategoryComponent} from './vacancies-category/vacancies-category.component';
import {VacanciesCategoryService} from './vacancies-category/vacancies-category.service';
import {JobListingComponent} from './job-listing/job-listing.component';
import {JobApplicationComponent} from './job-application/job-application.component';


import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {JwtInterceptor, ErrorInterceptor} from './_helpers';
import { UserProfileComponent } from './dashboard/user-profile/user-profile.component';
import { RefereeComponent } from './dashboard/referee/referee.component';
import { UploadsComponent } from './dashboard/uploads/uploads.component';
import { WorkExperienceComponent } from './dashboard/work-experience/work-experience.component';
import { PersonalInfoComponent } from './dashboard/personal-info/personal-info.component';
import { ManageApplicationsComponent } from './dashboard/manage-applications/manage-applications.component';
import { HeaderComponent } from './layout-components/header/header.component';
import { FooterComponent } from './layout-components/footer/footer.component';
import { MainLayoutComponent } from './layout-components/main-layout/main-layout.component';
import { MainContentComponent } from './layout-components/main-content/main-content.component';
import { BreadcrombComponent } from './layout-components/breadcromb/breadcromb.component';
import { PageHeaderComponent } from './layout-components/page-header/page-header.component';
import { ClientDashboardSidebarComponent } from './layout-components/client-dashboard-sidebar/client-dashboard-sidebar.component';
import { DashboardStatisticsComponent } from './dashboard/dashboard-statistics/dashboard-statistics.component';
import { ProfileGuideComponent } from './dashboard/profile-guide/profile-guide.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import {NgxDocViewerModule} from 'ngx-doc-viewer';
import { EliminationFormComponent } from './elimination-form/elimination-form.component';
import { JobDescriptionComponent } from './job-description/job-description.component';
import { BrowseApplicationComponent } from './browse-application/browse-application.component';
import { VerificationCodeComponent } from './auth/verification-code/verification-code.component';
import { CvComponent } from './dashboard/cv/cv.component';
import { FeedbackPopupComponent } from './vacancies-category/feedback-popup/feedback-popup.component';
import { CharterComponent } from './charter/charter.component';
import { PdfViewer } from '@syncfusion/ej2-pdfviewer';
import { ComplaintsComponent } from './components/complaints/complaints.component';
import { EmailService } from './_services/email.service';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [
    AppComponent,
    VacanciesCategoryComponent,
    JobListingComponent,
    JobApplicationComponent,
    routingComponents,
    UserProfileComponent,
    RefereeComponent,
    UploadsComponent,
    WorkExperienceComponent,
    PersonalInfoComponent,
    ManageApplicationsComponent,
    HeaderComponent,
    FooterComponent,
    MainLayoutComponent,
    MainContentComponent,
    BreadcrombComponent,
    PageHeaderComponent,
    ClientDashboardSidebarComponent,
    DashboardStatisticsComponent,
    ProfileGuideComponent,
    EliminationFormComponent,
    JobDescriptionComponent,
    BrowseApplicationComponent,
    VerificationCodeComponent,
    CvComponent,
    FeedbackPopupComponent,
    CharterComponent,
    ComplaintsComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    PdfViewerModule, // <- Add PdfViewerModule to imports
    NgxDocViewerModule,
    // CKEditorModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    VacanciesCategoryService,
    EmailService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
